export const version = '3.0.39-rc.1';
